<template>
    <div>
        <div id="tosc1target"></div>

    </div>
</template>

<script>
export default {
    name: "reservationsStudio",
    data() {
        return {
            showReservation: true,
        };
    },

    mounted() {
        // Charger le premier script et initialiser la première cible
        const script1 = document.createElement("script");
        script1.src = "https://resc.deskline.net/DW5/start/RESA32/c8a5c7a7-a960-4321-a02a-3d75766ac542/index.js";
        script1.async = true;
        script1.onload = () => {
            window.dw = window.dw || function () { (dw.q = dw.q || []).push(arguments) };
            dw(
                'settings', 'c8a5c7a7-a960-4321-a02a-3d75766ac542',
                {
                    "context": {
                        "serviceProviderId": "26cc0d45-0a36-4674-8bbd-2d19dfedc69b"
                    },
                    "lang": 'fr',
                    "target": "tosc1target"
                }
            );
        };
        document.head.appendChild(script1);
    },

    beforeDestroy() {
        // Décharger les scripts lorsque le composant est détruit pour éviter les fuites mémoire
        const script1 = document.querySelector('script[src="https://resc.deskline.net/DW5/start/RESA32/c8a5c7a7-a960-4321-a02a-3d75766ac542/index.js"]');
        if (script1) {
            script1.remove();
        }

    },

    watch: {},

    methods: {},
};
</script>